import { motion } from "framer-motion";

export default function ErrorPage() {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#010710] px-6 text-white">
      <div className="relative text-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-xs font-medium uppercase tracking-[0.25em] text-white/25"
        >
          Error
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.1,
            duration: 0.7,
            ease: "easeOut",
          }}
          className="mt-5 text-[7rem] font-medium leading-none tracking-[-0.07em] text-white sm:text-[10rem]"
        >
          404
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.25,
            duration: 0.7,
          }}
        >
          <h2 className="mt-5 text-xl font-medium tracking-tight text-white/80 sm:text-2xl">
            This page doesn't exist.
          </h2>

          <p className="mx-auto mt-4 max-w-md text-sm leading-7 text-white/35 sm:text-base">
            The page you're looking for may have been moved, removed, or never
            existed in the first place.
          </p>
        </motion.div>

        <motion.a
          href="/"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.4,
            duration: 0.7,
          }}
          className="group mt-9 inline-flex items-center gap-2 text-sm font-medium text-white transition-colors hover:text-white/70"
        >
          Back to home
          <span className="text-white/30 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
            ↗
          </span>
        </motion.a>
      </div>
    </main>
  );
}
